import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/services/api.service';
import { environment } from 'src/environment/environment';
import { CreateUserRequest, UpdateUserRequest, UserResponse } from '../models/users.model';

@Injectable({ providedIn: 'root' })
export class UsersApiService extends ApiService {
  getUsers$(): Observable<UserResponse[]> {
    return this.get('/Users');
  }

  createUser$(request: CreateUserRequest): Observable<UserResponse> {
    return this.post('/Users', request);
  }

  getUser$(uniqueId: string): Observable<UserResponse> {
    return this.get(`/Users/${uniqueId}`);
  }

  updateUser$(uniqueId: string, request: UpdateUserRequest): Observable<UserResponse> {
    return this.put(`/Users/${uniqueId}`, request);
  }

  deactivateUser$(uniqueId: string): Observable<void> {
    return this.post(`/Users/${uniqueId}/deactivate`);
  }

  activateUser$(uniqueId: string): Observable<void> {
    return this.post(`/Users/${uniqueId}/activate`);
  }

  deleteUser$(uniqueId: string): Observable<void> {
    return this.post(`/users/${uniqueId}/purge`);
  }
}

export const apiUsersProtectedResources = [
  {
    httpMethod: 'GET',
    scopes: [...environment.protectedResources.apiUsers.scopes.read],
  },
  {
    httpMethod: 'POST',
    scopes: [...environment.protectedResources.apiUsers.scopes.write],
  },
  {
    httpMethod: 'PUT',
    scopes: [...environment.protectedResources.apiUsers.scopes.write],
  },
];
